export default function HobbiesSection() {
  return (
    <section id="hobbies" className="py-12 px-6 lg:px-12 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-2 items-center">
          <div className="space-y-8">
            <div className="flex items-center gap-2">
              <div className="w-2 h-2 bg-black rounded-full"></div>
              <span className="text-sm tracking-widest text-gray-600" style={{ fontFamily: 'Montserrat, sans-serif' }}>HOBBIES</span>
            </div>
            
            <div>
              
              <div className="space-y-6">
                <div className="flex items-start gap-4 group">
                  <div className="w-12 h-12 rounded-full bg-orange-100 flex items-center justify-center flex-shrink-0 group-hover:bg-orange-500 transition-colors">
                    <i className="ri-basketball-line text-xl text-orange-600 group-hover:text-white transition-colors"></i>
                  </div>
                  <div>
                    <h3 className="text-xl lg:text-2xl font-bold text-gray-900" style={{ fontFamily: 'Noto Sans JP, sans-serif' }}>球技（特にバレーボール）</h3>
                  </div>
                </div>
                
                <div className="flex items-start gap-4 group">
                  <div className="w-12 h-12 rounded-full bg-orange-100 flex items-center justify-center flex-shrink-0 group-hover:bg-orange-500 transition-colors">
                    <i className="ri-cup-line text-xl text-orange-600 group-hover:text-white transition-colors"></i>
                  </div>
                  <div>
                    <h3 className="text-xl lg:text-2xl font-bold text-gray-900" style={{ fontFamily: 'Noto Sans JP, sans-serif' }}>ラテアートの練習</h3>
                  </div>
                </div>
                
                <div className="flex items-start gap-4 group">
                  <div className="w-12 h-12 rounded-full bg-orange-100 flex items-center justify-center flex-shrink-0 group-hover:bg-orange-500 transition-colors">
                    <i className="ri-hammer-line text-xl text-orange-600 group-hover:text-white transition-colors"></i>
                  </div>
                  <div>
                    <h3 className="text-xl lg:text-2xl font-bold text-gray-900" style={{ fontFamily: 'Noto Sans JP, sans-serif' }}>DIY</h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <div className="relative h-[600px]">
            <div className="absolute top-0 right-0 w-4/5 h-2/5 rounded-2xl overflow-hidden shadow-xl">
              <img 
                src="https://public.readdy.ai/ai/img_res/235995af8e011adb80bd51890ac815dc.jpg"
                alt="Volleyball"
                className="w-full h-full object-cover object-top"
              />
            </div>
            
            <div className="absolute bottom-1/3 left-0 w-3/5 h-2/5 rounded-2xl overflow-hidden shadow-xl">
              <img 
                src="https://readdy.ai/api/search-image?query=Beautiful%20latte%20art%20heart%20pattern%20in%20white%20ceramic%20cup%2C%20artistic%20coffee%20foam%20design%2C%20clean%20minimalist%20cafe%20background%2C%20soft%20natural%20lighting%20highlighting%20the%20delicate%20milk%20foam%20texture%20and%20barista%20craftsmanship%2C%20warm%20and%20inviting%20atmosphere&width=500&height=400&seq=hobbies-latte-art-001&orientation=landscape"
                alt="Latte Art"
                className="w-full h-full object-cover object-top"
              />
            </div>
            
            <div className="absolute bottom-0 right-0 w-3/5 h-2/5 rounded-2xl overflow-hidden shadow-xl">
              <img 
                src="https://readdy.ai/api/search-image?query=Hands%20working%20on%20DIY%20woodworking%20project%20with%20tools%20and%20materials%2C%20creative%20craftsmanship%20in%20home%20workshop%2C%20clean%20organized%20workspace%20with%20simple%20background%2C%20natural%20lighting%20emphasizing%20the%20satisfaction%20of%20handmade%20creation%20and%20building%20skills&width=500&height=400&seq=hobbies-diy-001&orientation=landscape"
                alt="DIY"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}